export default "__VITE_ASSET__PimNc20A__"